import { render, staticRenderFns } from "./QuoteIndex.vue?vue&type=template&id=1012f411&scoped=true&"
import script from "./QuoteIndex.vue?vue&type=script&lang=js&"
export * from "./QuoteIndex.vue?vue&type=script&lang=js&"
import style0 from "./QuoteIndex.vue?vue&type=style&index=0&id=1012f411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012f411",
  null
  
)

export default component.exports